{
  "legalConfirmLabel": "Fermer",
  "legalCopyright": "Copyright © {copyrightYears} Adobe Inc. All rights reserved.",
  "legalPrivacyPolicy": "Politique de confidentialité",
  "legalTermsOfUse": "Conditions d’utilisation",
  "legalTermsOfUseLink": "https://www.adobe.com/go/experiencecloudterms_fr",
  "profileLegalNoticesMenuItem": "Informations juridiques"
}
